common:
  save: Sauvegarder
animations:
  stage-transitions:
    title: Désactiver les transitions de scène
  use-page-specific-transitions:
    description: >-
      Certaines pages auront leurs propres transitions, ceci remplacera les transitions de scène.
    title: Utiliser les transitions spécifiques à chaque page
dialogs:
  onboarding:
    official:
      title: AIRI Official Provider
    title: Bienvenue dans AIRI!
    description: Configurez votre premier fournisseur d’IA pour commencer.
    selectProvider: Choisissez un fournisseur d'IA.
    configureProvider: Configurer {provider}
    apiKey: Clé API
    apiKeyHelp: Obtenez votre clé API {provider} et collez-la ici
    baseUrl: URL de base
    baseUrlHelp: URL de l'endpoint API (utilisez la valeur par défaut si vous n’êtes pas sûr)
    accountId: ID du compte
    validationRunning: Tests en cours
    validationSuccess: Validation de la configuration réussie
    validationPartial: Configuration partiellement validée
    validationFailed: La validation de la configuration a échouée.
    validationError: 'Erreur de validation: {error}'
    testGeneration: Tester l’API
    testGenerationRunning: Test en cours...
    testGenerationFailed: Échec du test
    retryPingCheck: Réessayer
    skipForNow: Passer pour l'instant
    saveAndContinue: Sauvegarder et Continuer
    next: Suivant
    retry: Réessayer
    credentialsSafeLabel: Gardez vos clés API et identifiants en sécurité !
    credentialsSafeLocal: >-
      AIRI fonctionne entièrement en local sur votre PC et nous ne volerons jamais vos identifiants pour les fournisseurs d'IA / LLM. Gardez toutefois à l'esprit que vos clés API sont des informations sensibles. Veillez à les conserver en lieu sûr et à ne les partager avec personne.
    credentialsSafeOpenSource: >-
      AIRI est open source sur {github}, si vous souhaitez vérifier comment nous gérons vos identifiants, n'hésitez pas à inspecter notre code.
    enableChatCheck: >-
      Autoriser AIRI à envoyer un message "ping" au premier modèle de chat disponible pour vérifier sa disponibilité
    start: Commençons !
    loginPrompt: Connectez-vous pour utiliser le fournisseur officiel AIRI et bénéficier de la meilleure expérience.
    loginAction: Se connecter
    setupWithoutSigningIn: Configurer avec votre fournisseur
    flux: Flux
    buyFlux: Charge Flux
    select-model: Choisissez un modèle
    no-models: Pas de modèle disponible
    no-models-help: >-
      Veuillez revenir à l’étape précédente et vérifier votre clé API, ou bien vérifier la connexion réseau.
    permissions:
      title: Notifications
      description: Vous pouvez autoriser les notifications maintenant ou continuer et les configurer plus tard.
      notificationsTitle: Notifications
      notificationsDescription: Autorisez les rappels et les mises à jour de statut importantes.
      notificationsAction: Demander l'autorisation de notification
      notificationsNotGrantedHint: En cas de refus, vous pourrez activer les notifications plus tard dans les Réglages iOS.
      openSettings: Ouvrir les Réglages iOS
      optionalHint: Vous pouvez continuer même si l'autorisation de notification n'est pas accordée.
      stateUnknown: Non demandé
      stateRequesting: Demande en cours...
      stateGranted: Accordée
      stateNotGranted: Non accordée
  bug-report:
    title: Bug report (´;ω;`)ヾ(･∀･`)
    subtitle: Oops, sorry we made something wrong. Would you mind telling us what happened?
    trigger-label: Report a Bug
    submit-label: Send Bug Report
    triage-description: Include screenshot and page context to help us triage this issue.
    description-placeholder: Steps to reproduce, expected behavior, and actual behavior
    include-current-page-screenshot: Include current page screenshot
    manual-media:
      label: Manually choose screenshots / recordings
      optional: Optional.
    media-files:
      label: Media files
      description: 'Optional: manually select.'
      placeholder: Choose screenshot or video file
      selected-count: '{count} file(s) selected'
    last-submitted-preview: Last Submitted Payload Preview
language:
  title: Langage
  description: |
    Langue de l'interface. Vous pourrez définir la langue des personnages plus tard.
controls-island:
  icon-size:
    title: Taille des icônes de l'îlot de contrôle
    description: Ajuster la taille des icônes de l'îlot de contrôle
    auto: Auto (réactif)
    large: Grande (défaut)
    small: Petite
analytics:
  notice:
    title: Statistiques d'utilisation
    description: >-
      AIRI collecte des statistiques d'utilisation anonymes pour nous aider à comprendre comment l'application est utilisée et améliorer sa stabilité. Aucune donnée personnelle n'est collectée.
    privacyPrefix: Read the
    privacyLink: politique de confidentialité
    onboardingHint: Vous pouvez désactiver les statistiques plus tard dans Paramètres > Système > Général.
    settingsHint: Vous pouvez désactiver les statistiques à tout moment.
  toggle:
    title: Activer les statistiques d'utilisation
    description: Désactivez cette option pour ne plus participer à la collecte de statistiques.
  disabled:
    title: Statistiques désactivées pour cette version de développement
model-select:
  panel-callout:
    support-status-header: We support both 2D and 3D models
    support-status: >
      Click {select-button} to select or import models. Currently, {zip} (for Live2D and Spine models) and {vrm} (for VRM models) are supported.
    model-type-example: >
      Neuro-sama uses 2D model driven by framework developed by Live2D Inc, while Grok Ani (in Grok Companion) uses 3D model driven by VRM / MMD open formats.
  select-model:
    title: Model Selector
    button: Select model
    select: Pick
    import: Import
    remove: Remove
    confirm: Confirm
live2d:
  change-model:
    from-file: Charger depuis un Fichier
    from-file-select: Sélectionner
    from-url: Charger depuis une URL
    from-url-confirm: Charger
    from-url-placeholder: Entrer l'URL d'un modèle Live2D
    title: Changer de Modèle
  edit-motion-map:
    title: Modifier la carte des mouvements
  map-motions:
    play: Jouer le mouvement
    title: Cartographier les mouvements
  title: Paramètres Live2D
  scale-and-position:
    title: Échelle et position
    scale: Échelle
    x: X
    'y': 'Y'
  switch-to-vrm:
    title: Passer à l’avatar 3D ?
    change-to-vrm: Cliquez ici pour passer aux paramètres de l’avatar 3D (VRM)
  theme-color-from-model:
    title: Extraire les couleurs du modèle
    description: >
      Extract prominent colors from current rendering canvas. Click on the color to apply it to AIRI. Try to extract multiple times, with the model in different poses, if the colors are not desirable.
    button-extract:
      title: Extraire
  animation:
    title: Animation
    focus:
      title: Enable mouse tracking
      description: Look at the cursor while it is moving. Idle eye movement resumes after the cursor stops.
      offset: Eye offset(%)
    force-idle-eye-animation:
      title: Idle eye movement
      description: Randomly look around when there is no active cursor focus.
    blink-enable:
      title: Enable blink
      description: Let the model blink.
    auto-blink:
      title: Auto
      description: Use default blinking animation of the model
    force-auto-blink:
      title: Force
      description: Force blinking animation with external timer
    blink-mode:
      title: Blink mode
      description: Choose the model built-in blink or AIRI's forced blink timer.
    idle-motion:
      title: Idle animation
      no-motion: No animation available
      placeholder: Select animation
      disable-motion: Disabled
      disable-motion-description: Disable idle animation
  parameters:
    title: Model Parameters
    render-scale:
      title: Render scale
    fps:
      title: FPS
      description: Limit rendering frame rate
      options:
        unlimited: '∞'
    shadow: Drop shadow
    reset-parameters: Reset to default parameters
  clear-model-cache: Clear model cache
  expressions:
    title: Expressions
    override-toggle: Expression system
    sdk-preset-preserved-notice: >
      SDK expression manager and eye blink are preserved when disabled.
    no-expression: No expressions available for this model.
    llm-integration-wip: LLM tool integration is not yet wired up.
    save-default: Save expression defaults
    reset: Reset all expressions
    expose-to-llm-toggle: Expose to LLM
    expose-to-llm-options:
      none: None
      all: All
      custom: Custom
microphone: Microphone
models: Modèle
pages:
  account:
    title: Compte
    description: Consultez votre profil et gérez votre compte
    notLoggedIn: Connectez-vous pour accéder à votre compte et à toutes les fonctionnalités
    login: Sign in
    logout: Sign out
    fluxBalance: Solde de Flux
    viewFluxDetails: Voir les détails
    signedInAs: Connecté en tant que
    profile:
      tab: Profile
      title: Profile
      description: Manage your public display name.
      name:
        label: Display name
        placeholder: How others see you
      avatar:
        gravatarNotice: Avatar from Gravatar.
        gravatarLink: Manage on gravatar.com
      action:
        save: Save changes
      message:
        saved: Profile updated.
      error:
        fallback: We could not save your changes.
    connections:
      tab: Connected accounts
      title: Connected accounts
      description: Sign in to AIRI through these providers. Unlink to revoke access, then link again to switch to a different account.
      status:
        linked: Linked
        notLinked: Not linked
        linkedSince: Linked on {date}
      action:
        link: Link
        unlink: Unlink
      message:
        loading: Loading connected accounts...
        unlinked: '{provider} disconnected.'
        linked: '{provider} connected.'
        linkStarted: Redirecting to {provider}…
      error:
        listFailed: Could not load connected accounts.
        unlinkFailed: Could not unlink this account.
        linkFailed: Could not start the link flow.
        accountAlreadyLinkedToDifferentUser: Ce compte OAuth est déjà lié à un autre compte AIRI. Choisissez un autre compte fournisseur ou dissociez-le d'abord de l'autre compte AIRI.
        oauthCallbackFailed: Impossible de connecter ce compte OAuth. Réessayez ou choisissez un autre compte fournisseur.
        lastAccount: This is your only sign-in method. Set a password first before unlinking it.
    security:
      tab: Security
      title: Security
      description: Change your password. Your other devices will be signed out.
      setDescription: You signed in via a social provider, so there is no current password yet. We'll email a secure link to set one.
      currentPassword:
        label: Current password
        placeholder: Enter your current password
      newPassword:
        label: New password
        placeholder: At least 8 characters
      confirmPassword:
        label: Confirm new password
        placeholder: Repeat your new password
      action:
        changePassword: Change password
        sendSetLink: Email me a link to set my password
      message:
        changed: Password changed. Other sessions have been signed out.
        setLinkSent: Check {email} for the link to set your password.
      error:
        fallback: We could not change your password.
        setLinkFailed: We could not send the password setup link.
        passwordMismatch: New password and confirmation do not match.
        passwordSameAsCurrent: New password must differ from the current one.
    danger:
      tab: Danger Zone
      title: Danger Zone
      description: Irreversible account actions live here.
      deleteAccount:
        title: Delete account
        description: Permanently delete your account and personal data.
        action: Delete account
        modal:
          title: Delete account?
          warning: This cannot be undone. Active subscription will be canceled, Flux balance cleared.
          confirmEmail:
            label: Type your email to confirm
            placeholder: ''
            mismatch: Email does not match.
          confirm: Send confirmation email
          cancel: Cancel
        message:
          emailSent: Check {email} for the deletion link.
        error:
          fallback: Could not start deletion. Try again later.
  card:
    activate: Activer
    active: Actif
    active_badge: Actuellement actif
    cancel: Annuler l'action
    save: Enregistrer les modifications
    card_not_found: Carte non trouvée
    character: Personnage
    close: Fermer
    chat:
      provider: Chat / Fournisseur
    consciousness:
      model: Conscience / Modèle
    vision:
      provider: Vision / Fournisseur
      model: Vision / Modèle
    created_by: créé par
    creator_notes: Notes du créateur
    delete: Supprimer
    delete_card: Supprimer la carte
    delete_confirmation: Êtes-vous sûr de vouloir supprimer cette carte ?
    description: Utiliser les préréglages des cartes d'AIRI
    description_label: Description
    drop_here: Déposer pour téléverser
    create_card: Créer une nouvelle carte
    edit_card: Modifier la carte
    creation:
      identity: Identité
      name: Nom
      nickname: Surnom
      description: Description
      behavior: Comportement
      greetings: Salutations (une par ligne)
      settings: Paramètres
      version: Version
      create: Créer
      defaults:
        name: Nom
        personality: Vous êtes une personne normale, curieuse de tout.
        scenario: Vous vous êtes récemment réveillé et avez tout oublié de votre vie passée.
        systemprompt: Vous recevrez des messages et y répondrez comme un humain.
        posthistoryinstructions: N’oubliez pas d’imiter un humain.
      modules_info: >-
        Modules de configuration pour cette carte de personnage. Si non défini, la configuration par défaut sera utilisée.
      use_default: Utiliser la configuration par défaut
      use_default_not_configured: Utiliser la configuration par défaut (non configurée)
      fields_info:
        subtitle: >-
          Vous pouvez ici ajouter des détails sur le personnage que vous créez, expliquer son histoire et son contexte, et comment vos interactions devraient être répondues.
        name: Le nom officiel du personnage.
        nickname: Vous pouvez également donner un surnom qui sera utilisé en priorité.
        description: Description du personnage.
        notes: Si vous souhaitez ajouter des notes personnelles.
        personality: >-
          Décrivez ici la personnalité de votre personnage. Timide ? Curieux ? Autre chose ?
        scenario: Quel est l’environnement ? Quelle est la situation actuelle ?
        greetings_field: Salutations
        greetings: Comment votre personnage devrait dire « bonjour » ?
        systemprompt: Expliquez ici à l’IA comment elle doit répondre lorsqu’on l’interroge.
        posthistoryinstructions: Placez ici tout ce que l’IA doit lire après l’historique des messages.
        version: >-
          Version de la carte, vous devez l’incrémenter si vous apportez des modifications par rapport à une carte précédente.
        consciousness_model: Sélectionnez le modèle de conscience (modèle AB) pour ce caractère.
        speech_model: Sélectionnez le modèle de synthèse vocale et la voix pour ce personnage.
      errors:
        name: Le nom doit être valide ou non vide.
        version: 'Erreur : numéro de version invalide !'
        description: 'Erreur : vous devez fournir une description pour cette carte.'
        personality: 'Erreur : une personnalité doit être fournie pour ce personnage.'
        scenario: 'Erreur : un scénario est requis.'
        systemprompt: 'Erreur : veuillez fournir un prompt système.'
        posthistoryinstructions: 'Erreur : le prompt post-historique est requis.'
        invalid_artistry_json: 'Error: Artistry provider options contains invalid JSON.'
      none: None
    modules: Modules
    name_asc: Nom (A-Z)
    name_desc: Nom (Z-A)
    no_cards: Aucune carte pour le moment. Cliquez sur le bouton ci-dessus pour en téléverser une !
    no_results: Aucune carte correspondante trouvée
    personality: Personnalité
    posthistoryinstructions: Instructions post-historique
    recent: Récemment ajouté
    scenario: Scénario
    search: Rechercher des cartes...
    sort_by: Trier par
    body-model: Corps / Modèle d'affichage
    speech:
      provider: Parole / Fournisseur
      model: Parole / Modèle
      voice: Parole / Voix
    systemprompt: Prompt système
    title: Carte AIRI
    try_different_search: Essayez un autre terme de recherche
    export: Export
    exported: Card package exported
    export_failed: Failed to export card package
    imported: Card package imported
    import_missing_file: Card package is missing required files
    import_invalid_file: Card package file is invalid
    upload: Téléverser
    upload_desc: Click or drag an AIRI card package to import
  memory:
    description: Endroit où les souvenirs sont stockés et organisés
    title: Mémoire
  data:
    title: Données
    description: Gérer les données AIRI enregistrées, les exports et les réinitialisations
    sections:
      chats:
        title: Sessions de chat
        description: Exporter ou importer les sessions de chat enregistrées.
        export: Exporter les chats
        import: Importer les chats
        delete: Supprimer toutes les sessions de chat
      models:
        title: Modèles
        description: Supprimer les modèles Live2D/VRM importés.
        delete: Supprimer tous les modèles
      modules:
        title: Modules
        description: Réinitialiser les préférences et identifiants des modules.
        reset: Réinitialiser les paramètres des modules
      providers:
        title: Fournisseurs
        description: Réinitialiser tous les paramètres et identifiants du fournisseur.
        reset: Réinitialiser les paramètres du fournisseur
      danger:
        title: Zone dangereuse
        description: Actions irréversibles. Exportez ce dont vous avez besoin avant de continuer.
      all:
        title: Supprimer toutes les données
        description: Effacer tous les réglages, configurations de fournisseurs et modèles locaux.
        delete: Supprimer toutes les données
      desktop-folder:
        title: Ouvrir le dossier app data
        description: Ouvrez le dossier de données d'AIRI dans votre gestionnaire de fichiers.
        open: Ouvrir le dossier
      desktop:
        title: Réinitialiser les paramètres et états du bureau
        description: Effacer les paramètres du bureau AIRI et l'état d'exécution.
        center: Move desktop window to center
        reset: Réinitialiser les données du bureau
    confirmations:
      tooltip: Êtes-vous sûr(e) ?
      'yes': 'Oui'
    status:
      exported: Sessions de discussion exportées.
      imported: Sessions de discussion importées.
      import_error: Échec de l'importation des sessions. Veuillez vérifier le format du fichier.
      chats_deleted: Sessions de discussion supprimées.
      models_deleted: Modèles supprimés.
      modules_reset: Paramètres du module réinitialisés.
      providers_reset: Paramètres du fournisseur réinitialisés.
      all_deleted: Toutes les données locales ont été supprimées.
      desktop_window_centered: Desktop window moved to screen center.
      desktop_reset: Données du bureau réinitialisées.
  models:
    description: Live2D, VRM, Spine, etc.
    title: Modèles
    sections:
      section:
        live2d:
          title: Live2D
          description: Configurer les modèles et paramètres Live2D
        vrm:
          title: VRM
          description: Configurer les modèles et paramètres 3D VRM
        scene: Scène
  modules:
    beat_sync:
      description: Vibrez au rythme de la source audio
      title: Synchronisation du rythme (Beat Sync)
      sections:
        audio_source:
          actions:
            start_screen_capture: Démarrer la capture d'écran
            stop: Arrêter
          description: Sélectionnez une source audio pour la détection du rythme.
          title: Source audio
        beat_visualizer:
          title: Visualiseur de rythme
        parameters:
          advanced_parameters: Paramètres avancés
          description: Ajustez les paramètres de détection du rythme.
          title: Paramètres
          parameters:
            adaptive_threshold:
              description: >-
                Appliquer ou non des seuils adaptatifs basés sur la variance du signal dans le temps.
              label: Seuil adaptatif
            buffer_duration:
              description: Durée du tampon (buffer) d'analyse interne.
              label: Durée du tampon
            envelope_filter_frequency:
              description: >-
                Fréquence du filtre d'enveloppe appliqué pour lisser les variations d'énergie.
              label: Fréquence du filtre d'enveloppe
            highpass_filter_frequency:
              description: >-
                Fréquence du filtre passe-haut appliqué pour réduire les basses fréquences comme les bruits de sub-basses.
              label: Fréquence du filtre passe-haut
            lowpass_filter_frequency:
              description: >-
                Fréquence du filtre passe-bas appliqué pour réduire les hautes fréquences comme les voix.
              label: Fréquence du filtre passe-bas
            min_beat_interval:
              description: BPM maximum ou intervalle minimum entre les battements détectés.
              label: BPM Max / Intervalle de battement Min
            sensitivity:
              label: Sensibilité
            spectral_flux:
              description: Activer ou non la détection d'attaque (onset) basée sur le flux spectral.
              label: Flux spectral
            warmup:
              description: Si vous voulez un échauffement pour une détection de rythme plus précise.
              label: Échauffement
    artistry:
      title: Artistry
      description: Image generation, scene background and drawing.
      page:
        title: Artistry Provider Configuration
        description: Select the active backend provider for image generation. Characters can override this in their Card settings.
      providers:
        none:
          name: None
          description: Bypass and disable the image generation module globally.
        comfyui:
          name: ComfyUI (Local)
          description: Use a local ComfyUI instance via WSL for image generation.
        replicate:
          name: Replicate.ai (Cloud)
          description: Use cloud-based models via the Replicate API.
        nanobanana:
          name: Nano Banana (Preview)
          description: Use Google AI Studio for image preview and reactions.
      card:
        description: Configure how AIRI generates images and visual content.
        comfyui_empty: No ComfyUI workflows configured. Go to Settings → Providers → ComfyUI to upload a workflow template.
        exposed_fields: '{count} exposed fields'
        open_on_replicate: Open on Replicate
        instruction_sync:
          title: ComfyUI Instruction Sync
          description: A specialized prompt is ready for your {workflowName} workflow. Applying this will overwrite current widget instructions so the AI knows how to use this specific template.
          apply: Apply Recommended Prompt
          keep: Keep Existing
      provider: Artistry Provider
      spawn_mode:
        label: Manifestation Mode (Spawn Mode)
        description: Choose how images are delivered to the interface.
        options:
          bg: Background Environment
          inline: Inline Chat
          widget: Overlay Widget
          bg_widget: Dual (Background + Widget)
      autonomous:
        title: Cinematic Autonomy (Autonomous Artist)
        description: When enabled, the "Producer" runs in parallel to the character to decide if a visual is needed. This prevents the character from forgetting to manifest scenes.
        threshold: Manifestation Threshold
        threshold_description: Use {min} for aggressive scene creation or {max} to require stronger evidence before generating.
        threshold_min: Always Generate (0%)
        threshold_max: Strict (100%)
      model:
        label: Artistry Model (Optional Override)
        description: Model identifier if needed by provider
      prompt-prefix:
        label: Artistry Prompt Default Prefix
        description: Pre-pended to every prompt sent to the image generator.
      options:
        label: Artistry Provider Options (JSON)
      widget-instructions:
        label: Widget System Prompt
        description: Custom instructions for the AI on how to use the generation capabilities.
    categories:
      essential: Essential
      messaging: Messaging
      gaming: Gaming
      artistry: Artistry
    consciousness:
      description: Personnalité, modèle désiré, etc.
      sections:
        section:
          provider-model-selection:
            collapse: Réduire
            custom_model_placeholder: Entrez le nom du modèle personnalisé...
            current_model_label: 'Modèle actuel :'
            description: Sélectionnez le fournisseur LLM approprié pour la conscience
            error: Erreur lors du chargement des modèles
            health_check_failed: Échec de la vérification de l'état de santé
            no_providers_configured_title: Aucun fournisseur configuré
            no_providers_configured_description: Cliquez ici pour configurer vos fournisseurs de LLM
            expand: Développer
            loading: Chargement des modèles disponibles...
            manual_model_name: Nom du modèle
            manual_model_placeholder: Entrez le nom du modèle à utiliser avec ce fournisseur
            no_models: Aucun modèle disponible
            no_models_description: Aucun modèle trouvé pour ce fournisseur
            no_search_results: Aucun modèle correspondant
            no_search_results_description: Aucun modèle ne correspond à '{query}'. Essayez un autre terme.
            not_supported: Liste des modèles non supportée
            not_supported_description: Ce fournisseur ne supporte pas la fonctionnalité de liste des modèles
            search_placeholder: Rechercher des modèles...
            search_results: '{count} modèles trouvés sur {total}'
            show_less: Afficher moins
            show_more: Afficher plus
            subtitle: Sélectionnez un modèle par défaut auprès du fournisseur
            title: Modèle
      title: Conscience
    description: Synthèse, vision, parole, jeux, etc.
    gaming-factorio:
      description: Jouer à Factorio !
      title: Factorio
      enable: Activer l'intégration Factorio
      enable-description: Autoriser AIRI à interagir avec le jeu Factorio
      server-address: Adresse du serveur
      server-address-description: L'adresse IP ou le nom d'hôte du serveur Factorio
      server-address-placeholder: Entrez l'adresse du serveur (ex. localhost ou 192.168.1.100)
      server-port: Port du serveur
      server-port-description: Le numéro de port du serveur Factorio (par défaut 34197)
      username: Nom d'utilisateur
      username-description: Votre nom d'utilisateur sur le serveur Factorio
      username-placeholder: Entrez votre nom d'utilisateur Factorio
      configured: Factorio est correctement configuré !
    gaming-minecraft:
      description: Jouer à Minecraft !
      title: Minecraft
      enable: Activer l'intégration Minecraft
      enable-description: >-
        Include Minecraft self-knowledge in Stage chat turns and keep passive runtime visibility enabled.
      configured: Minecraft est correctement configuré !
      read-only:
        title: Shell en lecture seule
        description: >-
          Stage currently exposes Minecraft as a passive shell. Runtime status and traffic are visible here, but service configuration stays in the Minecraft service files.
      setup:
        title: Configuration
        description: >-
          Vous pouvez trouver les instructions de configuration du bot dans le fichier suivant
      runtime:
        title: Observed runtime
        connection: Connexion
        latest-context: Dernier contexte du bot
        waiting: En attente d'un nouvel envoi de contexte provenant du bot.
        unknown: Inconnu
      debug:
        title: Trafic Minecraft
        empty: Aucun trafic Minecraft observé pour l'instant.
        source: 'Source : {source}'
      status:
        service-online: Service en ligne
        service-offline: Service hors ligne
        no-runtime-context: Aucun contexte de bot observé pour l'instant
        last-context-seconds: 'Dernier contexte du bot : il y a {seconds}s'
        last-context-stale: 'Dernier contexte du bot : Obsolète'
    hearing:
      description: Configurer la reconnaissance vocale
      title: Audition
      sections:
        section:
          provider-selection:
            description: Sélectionnez le fournisseur de reconnaissance vocale approprié
          confidence-threshold:
            title: Confidence Threshold
            description: >-
              Filter out low-confidence transcriptions to reduce Whisper hallucinations. Values closer to 0 are more strict; drag to the leftmost to disable. Only effective for providers supporting Whisper API (e.g., OpenAI, Groq).
            disabled: Désactivé
            verbose-json-note: >-
              Remarque : Si votre fournisseur ne prend pas en charge les réponses verbose_json, ce paramètre n'aura aucun effet.
            verbose-json-unsupported: >-
              Your provider did not return verbose_json segments. Confidence filtering had no effect on the last transcription.
    memory-long-term:
      description: Paramètres et gestion de la mémoire à long terme
      title: Mémoire à long terme
    memory-short-term:
      description: Paramètres et gestion de la mémoire à court terme
      title: Mémoire à court terme
    messaging-discord:
      description: Chat et chat vocal via Discord
      title: Discord
      enable: Activer l'intégration Discord
      enable-description: Autoriser AIRI à interagir via Discord
      token: Jeton du bot
      token-description: Votre jeton de bot Discord
      token-placeholder: Entrez votre jeton de bot Discord
      configured: Discord est correctement configuré !
    speech:
      description: Synthèse vocale
      sections:
        section:
          playground:
            buttons:
              stop:
                label: Arrêter
            select-voice:
              loading: Chargement du modèle...
              required: Veuillez sélectionner une voix
          voice-pack:
            description: Select a curated voice for the active character
            empty: No Voice Packs available
            error: Error loading Voice Packs
            loading: Loading Voice Packs...
            title: Voice Pack
          provider-voice-selection:
            custom_model_placeholder: Entrez le nom du modèle personnalisé...
            custom_voice_placeholder: Entrez l’ID de la voix personnalisée...
            description: Sélectionnez le fournisseur de synthèse vocale approprié
            no_models: Aucun modèle disponible
            no_models_description: Aucun modèle trouvé pour ce fournisseur
            no_voices: Aucune voix disponible
            no_voices_description: Aucune voix trouvée pour ce fournisseur
            no_voices_hint: Vous pouvez entrer un nom de voix personnalisé ci-dessous.
            pause: Pause
            play_sample: Jouer l’exemple
            search_models_placeholder: Rechercher des modèles...
            search_models_results: '{count} modèles trouvés sur {total}'
            search_voices_placeholder: Rechercher des voix...
            search_voices_results: '{count} voix trouvées sur {total}'
            unsupported_voice_warning_title: Aucune voix prise en charge
            unsupported_voice_warning_content: >-
              Essayez un autre modèle ou fournisseur. Nous travaillons à prendre en charge toutes les voix pour ce modèle dès que possible. En cas d'urgence, n'hésitez pas à nous le signaler sur GitHub : https://github.com/moeru-ai/airi/issues.
            show_less: Afficher moins
            show_more: Afficher plus
            title: Fournisseur
          voice-settings:
            input-ssml:
              placeholder: Entrez le texte SSML...
            use-ssml:
              description: Activez pour saisir du SSML brut au lieu de texte simple
              label: Utiliser SSML personnalisé
      title: Parole
    title: Modules
    vision:
      description: Vision
      title: Vision
    x:
      description: Navigation et utilisation X / Twitter
      title: X / Twitter
      enable: Activer l'intégration X / Twitter
      enable-description: Autoriser AIRI à interagir avec X / Twitter
      api-key: Clé API
      api-key-description: Votre clé API X / Twitter
      api-key-placeholder: Entrez votre clé API X / Twitter
      api-secret: Secret API
      api-secret-description: Votre secret API X / Twitter
      api-secret-placeholder: Entrez votre secret API X / Twitter
      access-token: Jeton d'accès
      access-token-description: Votre jeton d'accès X / Twitter
      access-token-placeholder: Entrez votre jeton d'accès X / Twitter
      access-token-secret: Secret du jeton d'accès
      access-token-secret-description: Votre secret de jeton d'accès X / Twitter
      access-token-secret-placeholder: Entrez votre secret de jeton d'accès X / Twitter
      configured: X / Twitter est correctement configuré !
    mcp-server:
      title: MCP servers
      description: Configure MCP servers and bring their tools into AIRI.
      config-path: Config file
      runtime-title: État de l'exécution
      empty: No MCP servers yet — click "Add server" below to create one, or paste a config via "Edit JSON".
      error-title: Oops
      success-title: Done!
      existing:
        title: Configured
        description: Servers recorded in mcp.json. Click any row to expand and edit it.
        empty: Nothing here yet. Add one below!
      add:
        title: New
        description: "Fill in a new server, then click \"Save and restart\" — it'll move into \"Configured\" above."
        pending-badge: Unsaved
      status:
        unknown: not loaded
      actions:
        open-config: Reveal in file manager
        apply-and-restart: Save and restart
        restart: Restart MCP
        add-server: Add server
        add-env: Add var
        remove: Remove
        test: Test
        edit-json: Edit JSON
        close-json: Close
        format-json: Format
        reset-draft: Reset
        apply-json: Apply
        cancel: Cancel
        expand: Expand
        collapse: Collapse
      fields:
        identifier:
          label: Identifier
          description: Unique name; becomes the key in mcp.json.
          placeholder: e.g. filesystem
        command:
          label: Command
          description: Executable spawned over stdio.
          placeholder: e.g. npx
        args:
          label: Arguments
          description: One per line, in order.
          placeholder: "-y\nsome-package-name\n/tmp"
        cwd:
          label: Working directory
          description: Optional directory used as the process working directory.
          placeholder: e.g. /Users/you/project
        env:
          label: Environment
          description: Vars passed to the child process.
          key-placeholder: KEY
          value-placeholder: value
        enabled:
          label: Enabled
      json:
        title: Edit mcp.json
        description: 'Edit the raw JSON directly. Click "Apply" to load it into the form, then "Save and restart" to write it to disk.'
        placeholder: Paste mcp.json here…
      test:
        title: Test connection
        description: We'll spawn the server briefly to check the command works and see what tools it exposes.
        pick-server-label: Server
        no-servers: Nothing to test yet
        no-server-selected: Pick a server first.
        server-disabled: '"{name}" is disabled — enable it on the card first.'
        disabled-suffix: disabled
        untitled: untitled
        running: Testing…
        success: Connected! Found {count} tools in {ms}ms.
        failure: Connection failed after {ms}ms
      errors:
        empty-identifier: Server # {index} is missing an identifier.
        duplicate-identifier: Identifier "{name}" is used more than once — names need to be unique.
        empty-command: '"{name}" is missing a command.'
        invalid-shape: That doesn't look like a valid mcp.json — the root needs an "mcpServers" field.
      messages:
        opened: Opened {path} in your file manager
        json-applied: JSON applied to the form. Click "Save and restart" to persist it to disk.
        restarted: All restarted! {started} started, {failed} failed, {skipped} skipped.
  flux:
    title: Flux
    buy: Charge
    currency: Currency
    description: Flux actuel
    packagesError: Échec du chargement des offres. Veuillez réessayer plus tard.
    checkout:
      success: Payment successful! Your Flux has been topped up.
      canceled: Le paiement a été annulé.
      error: Une erreur est survenue. Veuillez réessayer plus tard.
    audit:
      title: Historique des transactions
      time: Heure
      type: Type
      detail: Détail
      amount: Montant
      typeAddition: Recharge
      typeConsumption: Utilisation
      typeInitial: Allocation initiale
      typePromo: Promo Grant
      loading: Chargement de l'historique...
      empty: Aucune transaction pour l'instant.
      loadMore: Charger plus
      delayHint: Les enregistrements d'utilisation peuvent être retardés jusqu'à 1 minute
      ttsRequests: requests
    packages:
      title: Offres de Flux
      buy: Charge
      description: Offres Flux disponibles.
  providers:
    catalog:
      edit:
        config-id-not-found: Configuration du fournisseur introuvable.
        definition-id-not-found: Définition du fournisseur introuvable.
        actions:
          more-options: Plus d'options
          delete: Supprimer
        validation:
          failed:
            title: Veuillez vérifier les paramètres du fournisseur, la validation a échoué.
            description: >-
              Vous pouvez enregistrer la configuration actuelle si vous souhaitez continuer.
            action: Enregistrer quand même
        config:
          common:
            fields:
              field:
                api-key:
                  label: Clé API
                  description: Clé API utilisée pour autoriser les requêtes auprès de ce fournisseur
                  placeholder: sk-...
                base-url:
                  label: URL de base
                  description: >-
                    L'URL de base utilisée pour se connecter au service distant. Ressemble souvent à http://localhost:11434/v1 ou https://exemple.com/v1.
                  placeholder: URL de base...
                headers:
                  label: En-têtes HTTP personnalisés
                  description: Ajouter des en-têtes HTTP personnalisés
                  key:
                    placeholder: Clé
                  value:
                    placeholder: Valeur
                thinking-mode:
                  label: Mode de réflexion
                  description: >
                    Contrôle le comportement de réflexion d'Ollama. GPT-OSS ne prend en charge que les niveaux bas/moyen/haut (low/medium/high).
                  options:
                    auto: Auto (par défaut du fournisseur)
                    disable: Désactiver
                    enable: Activer
                    low: Bas
                    medium: Moyen
                    high: Haut
        validators:
          actions:
            validate: Valider
          empty: Aucune étape de validation disponible.
          openai-compatible:
            check-config:
              title: Configuration
            check-connectivity:
              title: Connectivité
            check-supports-model-listing:
              title: Lister les Modèles
            check-supports-chat-completion:
              title: Complétion de chat
          status:
            validating: Validation en cours...
            valid: Réussi
            invalid: Erreur détectée
          title: Vérifications
        providers:
          provider:
            ollama:
              troubleshooting:
                validators:
                  openai-compatible-check-connectivity:
                    label: Configuration supplémentaire requise pour Ollama
                    content: >-
                      Nous sommes désolés que le test de connectivité pour Ollama ait échoué. Ne vous inquiétez pas, une configuration supplémentaire est nécessaire pour les instances Ollama. Vous devez définir explicitement <code>OLLAMA_HOST</code> lors du lancement de l'application ou du serveur CLI Ollama. Pour plus d'informations, consultez le <a href="https://airi.moeru.ai/docs/en/docs/manual/integrations/providers/chat/ollama">guide d'intégration Ollama</a>.
    common:
      continueAnyway: Continuer quand même
      goToModelSelection: Sélectionnez un Modèle
      fields:
        field:
          api-key:
            label: Saisie de clé API
      section:
        advanced:
          fields:
            field:
              headers:
                description: Ajouter des en-têtes HTTP personnalisés
                key:
                  placeholder: Clé
                label: En-têtes HTTP
                value:
                  placeholder: Valeur
          title: Avancé
        basic:
          description: Paramètres essentiels
          title: Basique
        voice:
          title: Paramètres de la voix
    labels:
      recommended: Recommended
    filters:
      pricing: Pricing
      deployment: Deployment
      all: All
      free: Free
      paid: Paid
      internal: Internal
      local: Local
      cloud: Cloud
    categories:
      chat:
        title: Chat
        description: Text generation model providers. e.g. OpenRouter, OpenAI, Ollama.
      vision:
        title: Vision
        description: Vision model providers for image understanding.
      speech:
        title: Speech
        description: Speech (text-to-speech) model providers. e.g. ElevenLabs, Azure Speech.
      transcription:
        title: Transcription
        description: >-
          Transcription (speech-to-text) model providers. e.g. Whisper.cpp, OpenAI, Azure Speech
      artistry:
        title: Artistry
        description: Image generation and design model providers. e.g. ComfyUI, Replicate.
        items:
          comfyui:
            description: Local image generation runner.
          replicate:
            description: Cloud-based model inference service.
          nanobanana:
            description: Google AI Studio Image Preview.
    helpinfo:
      title: Première fois ici ?
      description: >
        AIRI nécessite qu’au moins un fournisseur {chat} soit configuré pour penser et se comporter correctement. On peut le considérer comme le cerveau des personnages vivant dans le système AIRI.
    explained:
      chat: Fournisseurs de modèles de génération de texte, par ex. OpenRouter, OpenAI, Ollama.
      Speech: Fournisseurs de modèles de synthèse vocale, par ex. ElevenLabs, Azure Speech.
      Transcription: >-
        Fournisseurs de modèles de transcription (speech-to-text), par ex. Whisper.cpp, OpenAI, Azure Speech
    description: LLMs, fournisseurs vocaux, etc.
    provider:
      app-local-audio-transcription:
        title: Application (Locale)
        description: https://github.com/moeru-ai/xsai-transformers
      app-local-audio-speech:
        title: Application (Locale)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-transcription:
        title: Navigateur (Local)
        description: https://github.com/moeru-ai/xsai-transformers
      browser-local-audio-speech:
        title: Navigateur (Local)
        description: https://github.com/moeru-ai/xsai-transformers
      alibaba-cloud-model-studio:
        description: bailian.console.aliyun.com
        title: Studio de modèles Alibaba Cloud
      amazon-bedrock:
        title: Amazon Bedrock
        description: aws.amazon.com/bedrock
        config:
          api-key:
            label: Bedrock API Key
            description: Amazon Bedrock API key (generate in AWS Console → Bedrock → API Keys)
            placeholder: bedrock-...
          region:
            label: AWS Region
            description: AWS region where Bedrock is enabled (e.g. us-east-1, us-west-2)
      anthropic:
        description: anthropic.com
        title: Anthropic | Claude
        helpinfo:
          title: Avant de commencer
          description:
            part1: >-
              Bien qu’Anthropic ait récemment annoncé un support bêta pour la compatibilité SDK OpenAI
            part2: (vous pouvez en lire plus ici)
            part3: en raison de détails d’implémentation
            part4: >-
              des restrictions non alignées avec le SDK OpenAI, il n’est actuellement pas possible d’utiliser ce fournisseur dans le navigateur.
            part5: >-
              Si vous devez utiliser ce fournisseur, vous aurez besoin d’un proxy backend dédié comme une fonction serverless
            part6: ou des services contournant le CORS pour éviter les restrictions CORS.
      cloudflare-workers-ai:
        description: cloudflare.com
        fields:
          field:
            account-id:
              description: ID de compte Cloudflare
              label: ID de compte
              placeholder: Votre ID de compte Cloudflare
            api-key:
              placeholder: Saisir la clé API Cloudflare
        title: Cloudflare Workers AI
      common:
        status:
          validating: Validation en cours
          valid: La configuration semble valide.
        fields:
          field:
            pitch:
              description: 'Ajuster la hauteur de la voix synthétisée (ex : plus aiguë ou plus grave)'
              label: Hauteur
            speed:
              description: Ajuster la vitesse de la parole
              label: Vitesse
            volume:
              description: Ajuster le volume de la parole
              label: Volume
      deepgram-tts:
        description: deepgram.com
        title: Deepgram
      speech-noop:
        title: Aucun
        description: Aucune sortie vocale.
      comfyui:
        settings:
          title: ComfyUI (Local)
          heading: ComfyUI Native API
          description: Connect to your local ComfyUI and bring your own workflows.
          info:
            what_you_need:
              label: What You Need
              value: ComfyUI running locally or on your network.
            how_to_export:
              label: How To Export
              value: Enable Dev Mode → "Save (API Format)".
            scope_boundary:
              label: Scope Boundary
              value: Model downloads & node installs are your job.
          connection:
            title: Connection
            connected: Connected
            failed: Connection failed
            error_prefix: Error
            test: Test
            testing: Testing...
            unknown_error: Unknown connection error
            unknown_gpu: Unknown GPU
            server_url:
              label: Server URL
              description: The address where ComfyUI is running
              placeholder: http://localhost:8188
          cors:
            title: CORS Block Detected
            description: ComfyUI blocks requests from other applications by default. To allow AIRI to connect, you must start ComfyUI with the `--enable-cors-header "*"` flag.
            command: python main.py --enable-cors-header "*"
          workflows:
            title: Workflow Templates
            upload: Upload Workflow
            cancel_upload: Cancel
            empty: No workflows uploaded yet. Click "Upload Workflow" to import a workflow_api.json from ComfyUI.
            exposed_parameters: Exposed Parameters
            summary: '{nodes} nodes · {fields} exposed fields'
            remove: Remove
            config_snippet: Artistry Config Snippet
            copy_json: Copy JSON
            paste_hint: Paste this into your AIRI Card artistry config to override these nodes.
          upload:
            prompt: Drop or select a workflow_api.json file
            invalid_json: Invalid JSON
            workflow_name:
              label: Workflow Name
              description: Give this workflow a recognizable name
              placeholder: e.g. Anime Text2Img
            select_fields: 'Select fields to expose to the AI agent:'
            fields_exposed: '{count} field(s) exposed'
            save: Save Workflow
      replicate:
        settings:
          title: Replicate.ai
          heading: Replicate.ai Configuration
          description: Configure your cloud image generation settings.
          api_key:
            label: API Key
            description: Your Replicate API token (starts with r8_)
            placeholder: r8_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
          default_model:
            label: Default Model
            description: Fallback owner/model string to use if the character card doesn't specify one
            placeholder: black-forest-labs/flux-schnell
          aspect_ratio:
            label: Aspect Ratio
            description: Default image aspect ratio (e.g. 16:9, 1:1, 9:16)
            placeholder: '16:9'
          inference_steps:
            label: Inference Steps
            description: Number of steps for the diffusion process (lower is faster, higher is better quality)
      nanobanana:
        settings:
          title: Nano Banana
          heading: Nano Banana (Google AI Studio)
          description: Configure Google Gemini's native image generation capabilities.
          api_key:
            label: API Key
            description: Your Google AI Studio API Key
            placeholder: AIpk...
          preferred_model:
            label: Preferred Model
            description: The specific Gemini image preview model to use
          default_resolution:
            label: Default Resolution
            description: The target resolution for generated images
          model_options:
            nano_banana_2: Nano Banana 2 (Gemini 3.1 Flash Image)
            nano_banana_pro: Nano Banana Pro (Gemini 3 Pro Image)
            nano_banana: Nano Banana (Gemini 2.5 Flash Image)
      deepseek:
        description: deepseek.com
        title: DeepSeek
      elevenlabs:
        description: elevenlabs.io
        fields:
          field:
            simularity-boost:
              description: Adhérence à la voix originale
              label: Boost de similarité
            speaker-boost:
              description: Améliorer la similarité du locuteur
              label: Boost du locuteur
            speed:
              description: Vitesse de génération de la parole
              label: Vitesse
            stability:
              description: Stabilité et aléatoire de la voix
              label: Stabilité
            style:
              description: Exagération du style de la voix
              label: Style
        playground:
          buttons:
            button:
              test-voice:
                generating: Génération...
                label: Tester la voix
          fields:
            field:
              input:
                placeholder: Entrez le texte pour tester la voix...
              language:
                description: Sélectionnez la langue de la voix
                label: Langue
              voice:
                description: Sélectionnez la voix préférée
                label: Voix
          title: Terrain de test de la voix
          validation:
            error-missing-api-key: Veuillez entrer une clé API pour tester la voix.
        title: ElevenLabs
      kokoro-local:
        description: Synthèse vocale locale utilisant Kokoro-82M.
        fields:
          field:
            model:
              label: Choix du modèle
              description: Les modèles plus petits se chargent plus rapidement mais peuvent avoir une qualité légèrement inférieure.
        models:
          fp32-webgpu:
            description: >-
              Modèle en pleine précision utilisant WebGPU - Recommandé pour les appareils compatibles
          fp32:
            description: Modèle en pleine précision
          fp16:
            description: Demi-précision
          q8:
            description: Quantifié en 8-bit
          q4:
            description: Quantifié en 4-bit
          q4f16:
            description: 4-bit avec FP16
        playground:
          default-text: Bonjour ! Ceci est un test du système de synthèse vocale Kokoro.
          title: Zone d'essai vocale
        title: Kokoro TTS (Local)
      fireworks:
        description: fireworks.ai
        title: Fireworks.ai
      google-gemini-audio-speech:
        description: aistudio.google.com
        title: Google Gemini
      microsoft-speech:
        description: speech.microsoft.com
        fields:
          field:
            region:
              description: Région du service vocal
              label: Région
        title: Microsoft / Azure Speech
      index-tts-vllm:
        description: https://index-tts.github.io/
        title: Bilibili / IndexTTS
        callout_indextts2_unavailable_title: Support limité
        callout_indextts2_unavailable: Le support pour IndexTTS2 est actuellement indisponible. Veuillez utiliser IndexTTS.
      azure-ai-foundry:
        description: Azure AI Foundry
        title: Azure AI Foundry
      minimax:
        description: minimaxi.com
        title: MiniMax
      minimax-global:
        description: minimax.io
        title: MiniMax Global
      minimax-speech:
        description: minimax.io
        title: MiniMax Speech
      mimo:
        description: api.xiaomimimo.com
        title: Xiaomi MiMo
      mistral:
        description: mistral.ai
        title: Mistral
      moonshot:
        description: moonshot.ai
        title: Moonshot AI
      modelscope:
        description: modelscope.cn
        title: ModelScope
      novita:
        description: novita.ai
        title: Novita
      ollama:
        description: ollama.ai
        title: Ollama
      openai:
        description: openai.com
        title: OpenAI
      azure-openai:
        description: API Azure OpenAI
        title: Azure OpenAI
      openai-compatible:
        description: Compatible avec OpenAI
        title: Compatible avec OpenAI
      nvidia:
        description: build.nvidia.com
        title: NVIDIA NIM
      n1n:
        description: n1n.ai - Fournisseur d'API d'IA haute performance.
        title: n1n
      openrouter:
        description: openrouter.ai
        title: OpenRouter
      openrouter-audio-speech:
        description: openrouter.ai
        title: OpenRouter
      perplexity:
        description: perplexity.ai
        title: Perplexity
      player2:
        description: player2.game
        title: Player2
      together:
        description: together.ai
        title: Together.ai
      google-generative-ai:
        description: gemini.google.com
        title: Google Gemini
      groq:
        description: groq.com
        title: Groq
      featherless:
        description: featherless.ai
        title: Featherless AI
      lm-studio:
        description: lmstudio.ai
        title: LM Studio
      vllm:
        description: vllm.ai
        title: vLLM
      volcengine:
        description: volcengine.com
        fields:
          field:
            appId:
              description: ID de l’application du projet, que vous pouvez obtenir dans la Console
              label: ID de l’application
        title: Volcano Engine
      volcengine-coding-plan:
        description: Volcengine Coding Plan
        title: Volcengine Coding Plan
      byteplus:
        description: byteplus.com
        title: BytePlus
      byteplus-coding-plan:
        description: BytePlus Coding Plan
        title: BytePlus Coding Plan
      xai:
        description: x.ai
        title: xAI
      zai:
        description: z.ai
        title: Z.ai
      302-ai:
        description: 302.AI
        title: 302.AI
      comet-api:
        description: CometAPI.com
        title: Comet API
      cerebras:
        description: cerebras.ai
        title: Cerebras
      aliyun-nls:
        description: Aliyun NLS
        title: Aliyun NLS
      browser-web-speech-api:
        description: STT natif du navigateur (requiert Chrome/Edge/Safari)
        title: Web Speech API
      official:
        title: Fournisseur officiel
        description: Fournisseur d'IA officiel par AIRI.
        speech-title: Fournisseur vocal officiel
        speech-description: Fournisseur texte-to-speech officiel par AIRI.
        speech-streaming-title: Official Streaming Speech Provider
        speech-streaming-description: Official low-latency text-to-speech provider by AIRI (bidirectional WebSocket).
        transcription-title: Fournisseur de transcription officiel
        transcription-description: Fournisseur speech-to-text officiel par AIRI.
      transcriptions:
        playground:
          title: Terrain de test de transcription
      aihubmix:
        title: AIHubMix
        description: https://aihubmix.com (10 % de réduction)
    title: Fournisseurs
  connection:
    description: Configurer la connexion au serveur WebSocket
    title: Connexion
    websocket-url:
      description: 'Adresse complète du serveur WebSocket (ex: ws://localhost:6121/ws)'
      label: Adresse du serveur WebSocket
      placeholder: ws://localhost:6121/ws
    server-hostname:
      label: Expose On Network
      description: >-
        Choose whether the AIRI gateway only listens on this device or can be reached from your local network.
      advanced-label: Bind Hostname
      advanced-description: >-
        Use a specific hostname or IP address when you need manual network binding.
      options:
        this-device: This device
        all: All
        advanced: Advanced
    server-auth-token:
      label: Auth Token
      description: >-
        Security token required by remote clients that connect to this gateway. When left empty, AIRI generates a new token automatically.
      placeholder: Auto-generate
    qr:
      title: Connect from Stage Pocket
      description: >-
        Scan this QR code from Stage Pocket to try all reachable local network addresses and save the first working one.
      refresh: Refresh
      image-alt: AIRI server channel connection QR code
      candidates: Candidate addresses
      token-hint: >-
        The QR code includes the auth token so Stage Pocket can authenticate after connecting. Do not share it publicly.
      errors:
        title: QR code unavailable
        unavailable: Failed to prepare the connection QR code.
    qr-scan:
      title: Quick Connect
      description: Scan the QR code from Tamagotchi to quick connect
      instructions: Point the camera at the AIRI connection QR code.
      action: Scan
      success:
        title: Connected address saved
        description: 'URL been used: {url}'
      errors:
        title: QR scan failed
        failed: Failed to scan or connect with the QR code.
  system:
    color-scheme:
      description: Modifier le schéma de couleurs de la scène.
      title: Schéma de couleurs
    developer:
      description: Quelques options pour développeurs.
      title: Développeurs
    general:
      description: Thème sombre, langues, etc.
      title: Général
    description: Personnalisez votre scène !
    sections:
      section:
        custom-color:
          fields:
            field:
              primary-color:
                label: Couleur principale
                rgb-on:
                  title: Je veux que ce soit dynamique !
          title: Schéma de couleurs
        developer:
          title: Développeur
          sections:
            section:
              performance-visualizer:
                title: Visualiseur de performance
                description: Afficher/masquer l'incrustation FPS / tâches longues / mémoire
              markdown-stress:
                title: Test de stress Markdown
                description: Tester l'analyse et le rendu Markdown avec des charges de chat lourdes
              use-magic-keys:
                title: Outil useMagicKeys
                description: Tester les raccourcis
              audio-record:
                title: Enregistrement Audio
                description: Tester les composants ("composables") liés à l'audio
              background-gradient-blending:
                title: Mélange des couleurs du thème d'arrière-plan
                description: Tester le mélange et le thème
              background-removal:
                title: Suppression de l'arrière-plan (WebGPU requis)
                description: Utilitaire pour la suppression de l'arrière-plan
              chat:
                title: Chat
                description: Chat
              gesture-circle:
                title: Cercle de geste (Bureau uniquement)
                description: Tester la reconnaissance de gestes
              image:
                title: Image
                description: Image
              polaroid:
                title: Polaroid
                description: Utilitaire pour prendre des clichés de modèles
              context-flow:
                description: >-
                  Inspecter les mises à jour de contexte entrantes et les événements de flux de chat sortants
              websocket-inspector:
                title: Inspecteur WebSocket
                description: Inspecter le trafic WebSocket brut
              vibrant:
                title: Extraction de couleur
                description: Tester l'extraction de couleurs
              providers-transcription-realtime-aliyun-nls:
                title: Transcripteur temps réel Aliyun
                description: >-
                  Diffuser l'audio du microphone vers Aliyun NLS et inspecter les transcriptions en direct
              performance-playground:
                title: Zone d'essai de performance
                description: Expressions VRM + synchro labiale TTS
        theme-presets:
          presets:
            default:
              colors:
                color-1: Vert AIRI
              description: La couleur de thème verdâtre par défaut, offerte par AIRI !
              title: Couleur par défaut
            morandi:
              colors:
                color-1: Taupe
                color-2: Beige
                color-3: Gris cendré
                color-4: Taupe clair
                color-5: Ivoire
                color-6: Gris olive
                color-7: Sable
                color-8: Gris chaud
              description: Tons doux et feutrés inspirés des peintures de Giorgio Morandi
              title: Couleurs Morandi
            monet:
              colors:
                color-1: Bleu ciel
                color-2: Brume
                color-3: Sable
                color-4: Vert mousse
                color-5: Nénuphar
                color-6: Blé
                color-7: Bleu ardoise
                color-8: Sauge
              description: Palette impressionniste inspirée des œuvres de Claude Monet
              title: Couleurs Monet
            japanese:
              colors:
                color-1: Tanné
                color-2: Taupe chaud
                color-3: Terre d'ombre
                color-4: Café
                color-5: Bronze
                color-6: Or
                color-7: Moutarde
                color-8: Ambre
              description: Palette de couleurs traditionnelles japonaises
              title: Couleurs Japonaises
            nordic:
              colors:
                color-1: Bleu nordique
                color-2: Glace
                color-3: Fjord
                color-4: Acier
                color-5: Glacier
                color-6: Ardoise
                color-7: Nuage
                color-8: Pierre
              description: Palette de couleurs minimaliste scandinave
              title: Couleurs Nordiques
            chinese:
              colors:
                color-1: Aube rosée
                color-2: Rouge de Chine
                color-3: Brun fumé
                color-4: Vert bambou
                color-5: Violet foncé
                color-6: Jaune d'or
                color-7: Bleu azur
                color-8: Ocre
              description: >-
                Couleurs traditionnelles chinoises, issues des textiles anciens, de la porcelaine et des peintures
              title: Couleurs traditionnelles chinoises
          title: Préréglages de couleurs
    title: Apparence
  page:
    developers:
      open-devtools:
        title: Ouvrir les Outils de Développement
        button: Ouvrir
  credits:
    buy: Acheter
  scene:
    title: Scenes
    description: Customize the virtual environment for your characters.
    beta_label: Scenes System
    beta_description: Each character card specifies its own preferred background from this gallery. Setting it here will set it as the default for the currently active character.
    background_image:
      title: Active Character Background
      no_background: No background active for this character. Upload a square or landscape image for best results.
      upload: Upload to Gallery
      change: Change Background
      clear: Clear Default
    gallery:
      title: Scene Gallery
      empty: No images in gallery yet. Upload one above!
      set_as_global: Set as Character Default
      delete: Delete from Gallery
      global_badge: Character Default
      active_badge: Current Scene
      delete_confirm: Are you sure you want to delete this background?
    tip:
      label: Tip!
      description: Using a square image will leverage <b>cover</b> cropping in portrait mode, focusing on the center of the scene.
sections:
  section:
    general:
      title: Général
theme:
  title: Thème
  description: |
    Changez le thème de base d’AIRI, mode clair ou mode sombre.
title: Paramètres
voices: Voix
vrm:
  change-model:
    from-file: Charger depuis un fichier
    from-file-select: Sélectionner
    from-url: Charger depuis une URL
    from-url-confirm: Charger
    from-url-placeholder: Entrez l’URL du modèle VRM
    title: Changer de modèle
  title: Paramètres VRM
  scale-and-position:
    model-info-title: Informations sur la taille du modèle
    model-info-x: Largeur (X)
    model-info-y: Hauteur (Y)
    model-info-z: Profondeur (Z)
    tips: |
      Modifiez la position initiale du modèle VRM.
      Les axes de coordonnées sont visualisés.
    scale: Échelle
    x: Décalage X
    'y': Décalage Y
    z: Décalage Z
    fov: FOV (degré)
    rotation-y: Rotation (axe Y)
    camera-distance: Distance de la caméra
    eye-tracking-mode:
      title: Regarder vers
      options:
        option:
          camera: Caméra
          mouse: Souris
          disabled: Désactivé
  switch-to-vrm:
    title: Passer à l’avatar Live2D ?
    change-to-vrm: Cliquez ici pour passer aux paramètres de l’avatar Live2D
  theme-color-from-model:
    button-extract:
      title: Extraire
  skybox:
    skybox-intensity: Intensité de la SkyBox
    skybox-specular-mix: Mélange spéculaire
spine:
  title: Spine Settings
  scale-and-position:
    title: Scale And Position
    scale: Scale
    x: X
    'y': 'Y'
  theme-color-from-model:
    title: Extract colors from model
    button-extract:
      title: Extract
  animation:
    title: Animation
    idle-animation: Idle Animation
    mix-duration: Mix Duration (seconds)
    speed: Animation Speed
  appearance:
    title: Apparence
  variant:
    title: Variant
    current-variant: Active Variant
  skin:
    title: Skin
    current-skin: Current Skin
  rendering:
    title: Rendering
    max-fps: Maximum FPS
    render-scale: Render Scale
  fps:
    options:
      unlimited: Unlimited
websocket-secure-enabled:
  title: Activer WebSocket Sécurisé (WSS)
  description: >-
    Activez WSS (WebSocket Secure) pour permettre les connexions HTTPS pour mobile (pocket) en mode développement. Cela générera automatiquement un certificat auto-signé.
wip:
  title: Travail en cours
  description: >-
    Cette fonctionnalité est actuellement en cours de développement et n'est pas disponible publiquement. Revenez ultérieurement pour les mises-à-jour futures.
